import { lazy } from 'react';

import type {
  IntegrationDefinition,
  IntegrationLoaderContext,
  IntegrationMeta,
  NormalizedConnection,
} from '@mint-lib/integration-registry';
import type { QueryClient } from '@mint-lib/query-client';

import {
  APPSFLYER_URN,
  appsflyerConnectionRepository,
  fetchAppsFlyerConnections,
} from './repository.js';

/** AppsFlyer has no OAuth (token + app-ids form) — a one-way `adserver`, no `showAdAccounts`. */
export const appsflyerIntegrationMeta: IntegrationMeta = {
  urn: APPSFLYER_URN,
  displayName: 'AppsFlyer',
  i18nNamespace: '@mint-lib/appsflyer-integration',
  channel: 'adserver',
  direction: 'one-way',
};

export function createAppsFlyerIntegration(): IntegrationDefinition {
  return {
    meta: appsflyerIntegrationMeta,
    connection: {
      // Subpath imports (not relative) so Vite code-splits these into their
      // own chunks — never imported eagerly from this module.
      AddForm: lazy(() => import('@mint-lib/appsflyer-integration/add-form')),
      ManageForm: lazy(
        () => import('@mint-lib/appsflyer-integration/manage-form'),
      ),
      repository: appsflyerConnectionRepository,
      async prefetch(
        ctx: IntegrationLoaderContext,
      ): Promise<{ connections?: NormalizedConnection[] } | void> {
        const connections = await fetchAppsFlyerConnections(
          ctx.queryClient as QueryClient,
        );
        return { connections };
      },
    },
  };
}
